import { ITreeProvider, ITreeProviderService } from "./hierarchy";



export class TreeProviderService implements ITreeProviderService {

    readonly _serviceBrand: undefined;

    private readonly _providers: ITreeProvider[] = [];

    registerProvider(provider: ITreeProvider): void {
        if (!this._providers.includes(provider)) {
            this._providers.push(provider);
        }
    }

    unregisterProvider(provider: ITreeProvider): void {
        const index = this._providers.indexOf(provider);
        if (index !== -1) {
            this._providers.splice(index, 1);
        }
    }

    getProvider(object: object): ITreeProvider | null {
        for (const provider of this._providers) {
            if (provider.canParse(object)) {
                return provider;
            }
        }
        return null;
    }
}